'use strict'

###*
# Method to pass data to Optimize so the event/data shows in the splunk warehouse
#
# @async
# @param {String} eventName - Name of the event to emit to splunk
# @param {Object} [payload] - Data to emit to splunk (Optional)
###
trackEvent = (eventName, payload = {}) ->
  requestIdleCallback ->
    defaults =
      b: Cookie.get('b')
      pageId: location.pathname
    payload = Object.assign {}, payload, defaults
    OptimizeSuite?.TrackingHub?.add("#{eventName}", payload)
  return

module.exports = trackEvent



// WEBPACK FOOTER //
// ./src/frontend/helper/general/m_trackEvent.coffee